import React from 'react';
import { useState } from 'react';

// const Holidays = () => {
//   return (
//     <div>
//       nayan
//     </div>
//   );
// };

// export default Holidays;




const Holiday = () => {
  const [formData, setFormData] = useState({
    name: "",
    date: "",
    day: "",
  });
  const [message, setMessage] = useState("");
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  const getDayFromDate = (dateString) => {
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const date = new Date(dateString);
    return daysOfWeek[date.getDay()];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "date") {
      setFormData({ ...formData, date: value, day: getDayFromDate(value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/add-public-holiday`, {
        method: "POST",
        headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage(" " + data.message);
        setFormData({ name: "", date: "", day: "" });
      } else {
        setMessage(" " + data.error);
      }
    } catch (error) {
      setMessage("Error: " + error.message);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "linear-gradient(135deg,rgb(232, 233, 236),rgb(236, 234, 238))",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          width: "400px",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#333", marginBottom: "20px" }}>Add Public Holiday</h2>

        <label style={{ fontWeight: "bold", color: "#555", textAlign: "left", display: "block" }}>
          Holiday Name
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter Holiday Name"
          required
          style={{
            width: "100%",
            padding: "10px",
            margin: "5px 0 15px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        />

        <label style={{ fontWeight: "bold", color: "#555", textAlign: "left", display: "block" }}>
          Date
        </label>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
          style={{
            width: "100%",
            padding: "10px",
            margin: "5px 0 15px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        />

        <label style={{ fontWeight: "bold", color: "#555", textAlign: "left", display: "block" }}>
          Day
        </label>
        <input
          type="text"
          name="day"
          value={formData.day}
          readOnly
          placeholder="Select a date to auto-fill"
          style={{
            width: "100%",
            padding: "10px",
            margin: "5px 0 15px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            background: "#f5f5f5",
            cursor: "not-allowed",
          }}
        />

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "12px",
            background: "#764ba2",
            color: "#fff",
            fontSize: "16px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            transition: "0.3s",
          }}
          onMouseOver={(e) => (e.target.style.background = "#5b3d91")}
          onMouseOut={(e) => (e.target.style.background = "#764ba2")}
        >
          Add Holiday
        </button>

        {message && <p style={{ marginTop: "15px", fontWeight: "bold", color: "#333" }}>{message}</p>}
      </form>
    </div>
  );
};

export default Holiday;
